const imageDisenio = [
  "disenio_sonrisa5.webp",
  "disenio_sonrisa3.webp",
  "disenio_sonrisa4.webp",
  "disenio_sonrisa2.webp",
];
const imageBlanq = [
  "blanqueamiento1.webp",
  "blanqueamiento2.webp",
  "blanqueamiento3.webp",
  "blanqueamiento4.webp",
];
const imageBrackets = ["brackets2.webp", "brackets1.webp", "brackets3.webp"];
const imageRehabilitacion = [
  "rehabilitacion3.webp",
  "rehabilitacion2.webp",
  "rehabilitacion1.webp",
];
const imageRehabilitacionEst = [
  "rehabilitacion_est_port.webp",
  "rehabilitacion_est1.webp",
  "rehabilitacion_est2.webp",
  "rehabilitacion_est3.webp",
];
const imageRestauracion = ["restauracion1.webp", "restauracion2.webp"];
const imageLimpieza = ["limpieza1.webp", "limpieza2.webp", "limpieza3.webp"];
const imageOdontPed = ["odont_ped2.webp", "odont_ped1.webp", "odont_ped3.webp"];
const imageAlineadores = [
  "ortodoncia_port.webp",
  "ortodoncia3.webp",
  "ortodoncia2.webp",
  "ortodoncia1.webp",
];

export const gsdentalServices = [
  {
    name: "Diseño de Sonrisa",
    description:
      "Transforma tu sonrisa con nuestro servicio integral de diseño, combinando estética y funcionalidad dental.",
    image: "/images/gsdental/tratamientos/disenio_sonrisa5.webp",
    imageList: [...imageDisenio],
  },
  {
    name: "Blanqueamiento",
    description:
      "Recupera la blancura natural de tus dientes con nuestros tratamientos de blanqueamiento profesional, seguros y efectivos.",
    image: "/images/gsdental/tratamientos/blanqueamiento1.webp",
    imageList: [...imageBlanq],
  },
  {
    name: "Ortodoncia",
    description:
      "Mejora la alineación de tus dientes con brackets metálicos, usando técnicas ortodónticas modernas para lograr una sonrisa perfecta.",
    image: "/images/gsdental/tratamientos/brackets.webp",
    imageList: [...imageBrackets],
  },
  {
    name: "Ortodoncia Invisible",
    description:
      "Alinea tus dientes de forma discreta y cómoda con nuestros alineadores invisibles, una alternativa moderna a los brackets tradicionales.",
    image: "/images/gsdental/tratamientos/ortodoncia_port.webp",
    imageList: [...imageAlineadores],
  },
  {
    name: "Rehabilitación Dental",
    description:
      "Restaura la estructura de tus dientes dañados con tratamientos de coronas, puentes e implantes, devolviendo la funcionalidad completa a tu boca.",
    image: "/images/gsdental/tratamientos/rehabilitacion3.webp",
    imageList: [...imageRehabilitacion],
  },
  {
    name: "Rehabilitación Estética",
    description:
      "Mejora la apariencia de tu sonrisa con procedimientos estéticos avanzados como carillas, resinas de última generación y reconstrucciones que realzan la belleza natural de tus dientes.",
    image: "/images/gsdental/tratamientos/rehabilitacion_est_port.webp",
    imageList: [...imageRehabilitacionEst],
  },
  {
    name: "Restauración Dental",
    description:
      "Recupera la salud y estructura de tus dientes con obturaciones, incrustaciones, endodoncias y reconstrucciones de alta calidad.",
    image: "/images/gsdental/tratamientos/restauracion1.webp",
    imageList: [...imageRestauracion],
  },
  {
    name: "Limpieza Dental",
    description:
      "Elimina el sarro y las manchas superficiales con un procedimiento rápido, seguro y sin dolor. Ideal para mantener tu salud bucal en óptimas condiciones.",
    image: "/images/gsdental/tratamientos/limpieza1.webp",
    imageList: [...imageLimpieza],
  },
  {
    name: "Odontopediatría",
    description:
      "Cuidado dental especializado para niños, asegurando una experiencia positiva y amigable desde la primera visita al dentista.",
    image: "/images/gsdental/tratamientos/odont_ped2.webp",
    imageList: [...imageOdontPed],
  },
];
